exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".preview-inlineForm .el-form-item__label{color:#9e9e9e}.preview-inlineForm .el-form-item{width:300px;margin:4px 0}.preview-inlineForm .el-form-item__content{width:180px}.preview-dialog pre{margin:0;white-space:pre-line}.preview-dialog .el-form-item__label{color:#9e9e9e}.preview-dialog .el-form-item{margin:4px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2c887b67","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/message/viewEmailTpl.vue
// module id = 996
// module chunks = 23